<template>
  <section>
    <div class="flex-cover wrap">
      <div class="left">
        <h2>Business<br>Lines</h2>
        <p>事業内容</p>
      </div>
      <div class="right">
        <div class="business-line">
          <h3 class="line-number">01</h3>
          <div class="business-line-content">
            <div class="sp-title">
              <h3 class="line-number">01</h3>
              <h4>ホームページ制作</h4>
            </div>
            <p>
              ホームページの制作でクライアントの目的を達成します。もっとも得意なのは売上・集客のアップです。これまで1社も解約がないとおり、クライアントに結果を提供できます。
            </p>
            <img src="@/assets/u_create_top_001.webp" alt="U-CREATEのホームページで売上・集客アップ！">
          </div>
        </div>
        <div class="business-line">
          <h3 class="line-number">02</h3>
          <div class="business-line-content">
            <div class="sp-title">
              <h3 class="line-number">02</h3>
              <h4>自社求人サイト制作 <br class="sp-only">× 求人強化</h4>
            </div>
            <p>
              自社求人サイトを起点にした求人マーケティングで求人への応募を増やします。世の中に出回っていない、最新かつ効果のあるノウハウを提供。月平均20件の応募が増えた事例もあります。
            </p>
            <img src="@/assets/u_create_top_002.webp" alt="U-CREATEの求人サイトで求人強化！">
          </div>
        </div>
        <div class="business-line">
          <h3 class="line-number">03</h3>
          <div class="business-line-content">
            <div class="sp-title">
              <h3 class="line-number">03</h3>
              <h4>紙媒体のデザインと印刷</h4>
            </div>
            <p>
              名刺、チラシ、封筒や会社資料などの紙媒体の制作と印刷を行います。コスト重視の対応から、デザインに凝った対応まで可能です。
            </p>
            <img src="@/assets/u_create_top_003.webp" alt="U-CREATEで名刺、チラシ、封筒を作成！">
          </div>
        </div>
        <div class="business-line last">
          <h3 class="line-number">04</h3>
          <div class="business-line-content">
            <div class="sp-title">
              <h3 class="line-number">04</h3>
              <h4>集客強化</h4>
            </div>
            <p>
              SEO対策、ネット広告の運用、SNS運用、Googleビジネスプロフィール(MEO)による集客強化を実現します。クライアントの事業・商材に合った最適な集客方法を設計し、実行します。
            </p>
            <img src="@/assets/u_create_top_004.webp" alt="U-CREATEで集客強化を実現！">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BusinessLines",
}
</script>

<style lang="scss" scoped>
section {
  .flex-cover {
    padding: 150px 0;
    @media screen and (min-width: 768px) and (max-width: 1100px) {
      display: block;
      padding: 75px 20px;
    }
    @media screen and (max-width: 767px) {
      padding: 75px 20px;
    }
    .left {
      width: 30%;
      @media screen and (max-width: 1100px) {
        width: 100%;
      }
      h2 {
        color: var(--black);
        font-size: 70px;
        font-weight: 700;
        line-height: 4.5rem;
        margin-bottom: 10px;
        @media screen and (min-width: 768px) and (max-width: 1100px) {
          text-align: center;
        }
        @media screen and (max-width: 767px) {
          font-size: 60px;
          line-height: 3.5rem;
        }
      }
      p {
        color: var(--black);
        @media screen and (max-width: 1100px) {
          text-align: center;
        }
      }
    }
    .right {
      width: 65%;
      @media screen and (min-width: 768px) and (max-width: 1100px) {
        width: 85%;
        margin: auto;
      }
      @media screen and (max-width: 767px) {
        width: 100%;
        padding-top: 20px;
      }
      .business-line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 80px;
        .line-number {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 12%;
          aspect-ratio: 1/1;
          font-size: 40px;
          color: var(--white);
          border-radius: 999px;
          background-color: var(--sub2);
          margin-bottom: auto;
          @media screen and (max-width: 1100px) {
            display: none;
          }
        }
        .business-line-content {
          width: 83%;
          @media screen and (max-width: 1100px) {
            width: 100%;
          }
          .sp-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            .line-number {
              display: none;
              @media screen and (max-width: 1100px) {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 20%;
                aspect-ratio: 1/1;
                font-size: 30px;
                color: var(--white);
                border-radius: 999px;
                background-color: var(--sub2);
                margin-bottom: auto;
                @media screen and (min-width: 768px) and (max-width: 1100px) {
                  width: 15%;
                }
              }
            }
            h4 {
              width: 75%;
              font-size: 28px;
              margin: 0;
              line-height: 2.5rem;
              @media screen and (min-width: 768px) and (max-width: 1100px) {
                width: 80%;
                font-size: 30px;
              }
            }
          }
          h4 {
            font-size: 28px;
            margin-bottom: 10px;
          }
          p {
            line-height: 2rem;
            margin-bottom: 10px;
          }
          img {
            margin-top: 20px;
          }
        }
      }
      .last {
        margin: 0;
      }
    }
  }
}
</style>